export default "__VITE_ASSET__gXT_d_xf__"